import React from 'react';
import {can} from "../components/Permissions";
import {toAbsoluteUrl} from "../../../../_metronic/_helpers";

export function UnpaidAgentsLinkColumnFormatter(cellContent) {
  const disabledCondition = !(can('view', 'unpaidAgentsPage') && Boolean(cellContent));
  const buttonClassnames = `btn btn-icon btn-light btn-sm mx-3 custom-action-button
  ${disabledCondition ? 'disabled' : ''}`;

  return (
    <a
      className={buttonClassnames}
      href={cellContent}
      target={'_blank'}
      rel="noreferrer"
    >
      <img
        src={toAbsoluteUrl('/media/svg/Link_brandColor.svg')}
        alt="link"
        className={'h-20px'}
      />
    </a>
  );
}
